/**
 * building-application (建築申請) の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

// 🔴 公開するのは「お客様が入力する建築申込フォーム」だけ（/building-application/apply）。
//   `/building-application`（申請設計課の社内ボード）・/list・/dashboard は公開しない
//   （middleware は startsWith 判定なので /apply だけ載せれば社内ボードはスタッフ認証必須になる）。
//   以前は '/building-application' を公開しており、お客様CTA・営業コピーURLが社内ボードを
//   未認証で開けてしまっていた（#10812 の実CRUD配線と合わせて露出源）。apply へ移して塞ぐ。
export const BUILDING_APPLICATION_PUBLIC_PATHS = {
  pages: ['/building-application/apply'] as const,
  // verify-phone（本人確認）と申込POSTはお客様が呼ぶため公開必須（/api/building-application 配下）。
  apis: ['/api/building-application'] as const,
} as const
